import React from "react";
import { Link } from "react-router-dom";
import ProjectsSection from "../../components/ProjectsSection";
import Testimonials from "../../components/Testimonials";

const DigitalMarketing = () => {

  const projects = [
    { title: "SEO Growth Campaign", desc: "Boosted organic traffic by 120% in 3 months.", link: "#" },
    { title: "Social Media Strategy", desc: "Increased engagement & brand reach.", link: "#" },
  ];

  const testimonials = [
    { name: "Hassan Ali", role: "Founder", feedback: "Our traffic doubled within weeks." },
    { name: "Ayesha Khan", role: "Brand Manager", feedback: "Amazing marketing strategy execution." },
  ];

  return (
    <div className="text-white bg-black overflow-hidden">

      {/* HERO */}
      <section className="relative min-h-screen flex items-center justify-center text-center px-6">
        <div className="absolute w-[600px] h-[600px] bg-green-500/30 blur-[140px] rounded-full top-10 left-1/2 -translate-x-1/2"></div>

        <div className="relative z-10 max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-extrabold">
            Data-Driven <span className="text-green-400">Digital Growth</span>
          </h1>

          <p className="mt-6 text-gray-300 text-lg max-w-2xl mx-auto">
            We don’t just market — we build strategies that generate real traffic,
            real leads, and real revenue.
          </p>

          <div className="mt-10 flex gap-4 justify-center flex-wrap">
            <Link to="/contact" className="px-8 py-4 bg-green-500 rounded-full">
              Start Marketing
            </Link>

            <a href="https://calendly.com/thelogicwaves/30min" className="px-8 py-4 border rounded-full">
              Book Strategy Call
            </a>
          </div>
        </div>
      </section>

      {/* VALUE */}
      <section className="py-24 px-6 text-center max-w-5xl mx-auto">
        <h2 className="text-4xl font-bold mb-6">Marketing That Converts</h2>
        <p className="text-gray-400">
          We combine creativity, analytics, and performance marketing to deliver measurable growth.
        </p>
      </section>

      {/* SERVICES */}
      <section className="py-24 px-6 grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {[
          "SEO Optimization",
          "Social Media Marketing",
          "Paid Ads (Google/Facebook)",
          "Conversion Funnels",
          "Brand Strategy",
          "Analytics & Tracking"
        ].map((item, i) => (
          <div key={i} className="bg-white/5 p-6 rounded-xl border border-white/10 hover:scale-105 transition">
            <h3 className="text-green-400 font-semibold">{item}</h3>
          </div>
        ))}
      </section>

      {/* PROCESS */}
      <section className="py-24 text-center bg-[#0b1a35]">
        <h2 className="text-4xl font-bold mb-12">Our Marketing Process</h2>
        <div className="grid md:grid-cols-4 gap-8">
          {["Research","Strategy","Execution","Optimize"].map((step,i)=>(
            <div key={i}>
              <div className="text-green-400 text-2xl font-bold">{i+1}</div>
              <p>{step}</p>
            </div>
          ))}
        </div>
      </section>

      <ProjectsSection projects={projects} />
      <Testimonials testimonials={testimonials} />

      {/* CTA */}
      <section className="py-28 text-center bg-gradient-to-r from-green-500 to-teal-500 px-6">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Ready to Scale Your Business?
        </h2>
        <Link to="/contact" className="bg-black px-8 py-3 rounded-full">
          Contact Us
        </Link>
      </section>

    </div>
  );
};

export default DigitalMarketing;